import { HierarchyContextProps, IHierarchyActionUpdateDomainReplacement } from "./interface";

/**
 * Updates a domain replacement in the hierarchy context state.
 *
 * @param action - The action containing the updated domain replacement
 * @param state - The current hierarchy context state
 * @returns Updated hierarchy context state with the modified domain replacement
 */
export const hcr_updateDomainReplacement = (
  action: IHierarchyActionUpdateDomainReplacement,
  state: HierarchyContextProps,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw `hierarchyContextReducer: ${action.operation}: Hierarchy not assigned yet`;
  const ix = state.hierarchy.domainReplacements.findIndex(
    (dr) => dr.airid === action.domainReplacement!.airid,
  );
  if (ix > -1) {
    return {
      ...state,
      hierarchy: {
        ...state.hierarchy,
        domainReplacements: state.hierarchy.domainReplacements.map((dr) =>
          dr.airid === action.domainReplacement!.airid ? action.domainReplacement! : dr,
        ),
      },
    };
  }
  return state;
};
